// modalQueueConfig.ts
export enum ModalID {
  DAILY_PRIZE = 'DAILY_PRIZE',
  END_OF_GAME = 'END_OF_GAME',
  GAME_RESULTS = 'GAME_RESULTS',
  YETTEL_WIZARD = 'YETTEL_WIZARD',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  NEWSLETTER = 'NEWSLETTER'
}

export const modalPriorities: Record<ModalID, number> = {
  [ModalID.QUESTIONNAIRE]: 100,
  [ModalID.YETTEL_WIZARD]: 80,
  [ModalID.DAILY_PRIZE]: 60,
  [ModalID.GAME_RESULTS]: 40,
  [ModalID.END_OF_GAME]: 20,
  [ModalID.NEWSLETTER]: 10
};
